<div class="wrapper wrapper-content animated fadeInRight">
  <app-scorecard [scoringType]="'group'" [scorecardMode]="'scores'" [hideOfficialScorecards]="false"></app-scorecard>
</div>
